import { useEffect, useMemo, useState } from 'react';
import { getDemoUnitsForTestRide } from '@yme/api';
import { ENABLED_FOR_TEST_RIDE_ATTR } from '@yme/common/selectors';
import { useSelector } from '@yme/hooks/useSelector';
import { getCommercetoolsProjectKey, getIsoCountryCode } from '@yme/selectors/common';
import { getAttributeByName } from '@yme/selectors/helpers';
import { getTestRideUrl } from '@yme/utils/product';
export const useGetTestRideLink = (props) => {
    const { product, testRideLinksArray, isTestRideEnabled } = props;
    const [isDemoUnit, setIsDemoUnit] = useState(false);
    const [linkForTestRide, setLinkForTestRide] = useState(null);
    const isoCountryCode = useSelector(getIsoCountryCode);
    const projectKey = useSelector(getCommercetoolsProjectKey);
    const masterVariant = product?.variants.find((variant) => Boolean(variant.master));
    const masterProductSku = masterVariant?.sku ?? '';
    const productSkus = useMemo(() => {
        return product?.variants.map((unit) => unit.sku) || [];
    }, [product]);
    const isTestRideEnabledFromCT = masterVariant?.attributes.find(getAttributeByName(ENABLED_FOR_TEST_RIDE_ATTR))?.value || false;
    useEffect(() => {
        if (isoCountryCode && isTestRideEnabledFromCT && isTestRideEnabled) {
            getDemoUnitsForTestRide({
                productCodes: productSkus,
                isoCountryCode,
                projectKey,
            })
                .then((response) => {
                const responseData = response.data;
                const { productCodes } = responseData;
                const hasUnit = productSkus.some((element) => productCodes.includes(element));
                setIsDemoUnit(hasUnit);
            })
                .catch(() => setIsDemoUnit(false));
        }
    }, [isTestRideEnabled, isTestRideEnabledFromCT, isoCountryCode, productSkus, projectKey]);
    useEffect(() => {
        if (isDemoUnit && isTestRideEnabledFromCT) {
            const inRiverIds = product?.categories
                ?.filter((category) => category.published)
                .map((el) => {
                return Number(el.key.replace(/\D/g, ''));
            }) ?? [];
            const url = testRideLinksArray.find((link) => inRiverIds.includes(link.key));
            const requestTestRideLink = url
                ? getTestRideUrl({
                    url: url.value,
                    sku: masterProductSku,
                })
                : '';
            setLinkForTestRide(requestTestRideLink);
        }
    }, [
        isDemoUnit,
        isTestRideEnabledFromCT,
        masterProductSku,
        product?.categories,
        testRideLinksArray,
    ]);
    return {
        linkForTestRide,
    };
};
